import { Skeleton } from 'antd'
import { SkeletonProps } from 'antd/es/skeleton/Skeleton'
import React, { FunctionComponent, ReactNode } from 'react'
import styled, { css, FlattenSimpleInterpolation } from 'styled-components'

type GradientSkeleton = 'default' | 'squareButton'

interface BaseGradientSkeletonProps extends SkeletonProps {
  fromColor?: string
  toColor?: string
  endColor?: string
  className?: string
}

interface SquareButtonGradientSkeletonProps extends BaseGradientSkeletonProps {
  type: 'squareButton'
  width: string
  height: string
}

interface DefaultGradientSkeletonProps extends BaseGradientSkeletonProps {
  type?: 'default'
  width?: never
  height?: never
}

type GradientSkeletonProps =
  | SquareButtonGradientSkeletonProps
  | DefaultGradientSkeletonProps

const GradientSkeleton: FunctionComponent<GradientSkeletonProps> = ({
  fromColor,
  toColor,
  endColor,
  className,
  width,
  height,
  type = 'default',
  ...skeletonProps
}) => {
  return (
    <GradientSkeletonWrapper
      $endColor={endColor}
      $fromColor={fromColor}
      $height={height}
      $toColor={toColor}
      $width={width}
      className={className}
      type={type}
    >
      {((): ReactNode => {
        if (type === 'squareButton') {
          return <Skeleton.Button shape='square' {...skeletonProps} />
        }
        return <Skeleton {...skeletonProps} />
      })()}
    </GradientSkeletonWrapper>
  )
}

const GradientSkeletonWrapper = styled.div<{
  $fromColor?: string
  $toColor?: string
  $endColor?: string
  $width?: string
  $height?: string
  type?: GradientSkeleton
}>`
  .ant-skeleton {
    ${({ $fromColor, $toColor, $endColor }): FlattenSimpleInterpolation => css`
      --ant-skeleton-gradient-from-color: ${$fromColor};
      --ant-skeleton-gradient-to-color: ${$toColor};
      --ant-skeleton-color-gradient-end: ${$endColor};
    `}
  }

  ${({ type, $width, $height }): FlattenSimpleInterpolation =>
    type === 'squareButton'
      ? css`
          .ant-skeleton-element,
          .ant-skeleton-element > * {
            width: ${$width} !important;
            height: ${$height} !important;
          }

          opacity: 0.3;
        `
      : css``}
`

export default styled(GradientSkeleton)<GradientSkeletonProps>``
